import { ReactNode, useEffect, useRef, useState } from 'react';
import { ScrollRestoration, useLocation } from 'react-router-dom';

import Sidebar from '../sidebar';
import Navbar from '../navbar';
import Footer from '../footer';

import { useAppSelector } from '@/shared/hooks/store';
import { selectIsScrollVisible } from '@/store/slices/onboarding/selectors';
import { HeaderHeightContext } from '../../../../shared/components/header-height-context';
import IntercomAccessiBe from '@/shared/components/IntercomAccessiBe';



const Layout = ({ children, hasFooter = false, isThankYou }: { children?: ReactNode; hasFooter?: boolean, isThankYou?: boolean }) => {
    const showScroll = useAppSelector(selectIsScrollVisible);
    const [headerHeight, setHeaderHeight] = useState(0);
    const { pathname } = useLocation();
    const headerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setTimeout(() => window.scrollTo(0, 0), 0);
    }, [pathname]);

    useEffect(() => {
        if (headerRef.current) {
            setHeaderHeight(headerRef?.current?.getBoundingClientRect()?.height || 0);
        }
    }, []);

    return (
        <HeaderHeightContext.Provider value={headerHeight}>
            <ScrollRestoration />
            <div className={`flex min-h-screen flex-col ${showScroll ? 'h-screen overflow-hidden' : ''}`}>
                <div className={`fixed top-0 left-0 w-full h-[50px] z-50 ${isThankYou ? 'bg-[#faf4ef]' : 'bg-[#f5f9f7]'}`} />
                <div className="grid-row flex min-h-screen flex-col lg:grid lg:min-h-[calc(100vh_-_24px)] lg:grid-cols-[224px,1fr] lx:grid-cols-[267px,1fr]">
                    <Sidebar />
                    <div className={`relative flex flex-auto flex-col overflow-hidden ${isThankYou ? 'bg-[#faf4ef]' : 'pt-[83px] lg:pt-[78px]'}`}>
                        <Navbar headerRef={headerRef} hideTopBg />
                        <div className={`relative ${!isThankYou ? 'mx-auto w-[calc(100%_-_40px)] lg:w-[calc(100%_-_50px)] lx:w-[calc(100%_-_70px)] 3xl:w-[calc(100%_-_140px)] pb-28 md:pb-20' : 'pt-[6.3125rem] lg:pt-[6.8125rem] w-full'} flex-auto`}>
                            {children}
                        </div>
                    </div>
                </div>
                {hasFooter && <Footer />}
                <IntercomAccessiBe />
            </div>
        </HeaderHeightContext.Provider>
    );
};

export default Layout;
